import { usesBetaApi } from './backendEnvironment';

export const getGambitUrl = (hostname = window.location.hostname): string => usesBetaApi(hostname)
  ? 'https://uu65fefr5m.execute-api.us-east-1.amazonaws.com/prod/gambit'
  : 'https://engine-api.thefableapp.com/gambit';

export const GAMBIT_URL = getGambitUrl();
